import { render } from "./pandoraSection.vue?vue&type=template&id=70e56648"
import script from "./pandoraSection.vue?vue&type=script&lang=js"
export * from "./pandoraSection.vue?vue&type=script&lang=js"

import "./pandoraSection.vue?vue&type=style&index=0&id=70e56648&lang=scss&scoop=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__